import styled from 'styled-components';
import { Fab } from '@material-ui/core';
import Colors from '../../constants/color';

export const ButtonRounded = styled(Fab)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 50px;
  background-color: ${(props) => (props.key !== undefined ? props.key : Colors.grey7)};
  :hover {
    background-color: ${(props) => (props.key ? props.key : Colors.grey1)};
  }
`;
